import { Box, BoxProps } from '@mui/material'
import React from 'react'

interface Props extends BoxProps {
}

const RatesUtilityBar: ReactFC<Props> = ({ children, sx, ...restProps }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        bgcolor: 'background.paper',
        height: 48,
        alignItems: 'center',
        padding: '0 1rem',
        borderRadius: 2,
        ...sx
      }}
      {...restProps}
    >
      {children}
    </Box>
  )
}
export default RatesUtilityBar
